export default {
    'setIsOrder'(context: any, isOrder: any) {
        context.commit('setIsOrder', isOrder)
    }
};
